// this file contains all the themable styles and overrides

import styled from 'vue-styled-components'

const themeProps = {
  theme: Object
}

const ThemeWrapper = styled('div', themeProps) `
    .banner {
      border-bottom: 1rem solid ${props => props.theme.brandColor ? props.theme.brandColor : '#000'};
    }
    a.brand-link { color: ${props => props.theme.brandColor ? props.theme.brandColor : '#333'}; }
    .mapbox { background-color: ${props => props.theme.brandColor ? props.theme.brandColor : '#000'}; }
`

export default ThemeWrapper



// WEBPACK FOOTER //
// ./src/components/elements/ThemeWrapper.js